module.exports = __webpack_public_path__ + "img/exercise_background.ea8e1d32.png";